import './page.scss';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const Advertisers = () => {
  const { id } = useParams();
  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) el.scrollIntoView({ behavior: 'auto' });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>Prohibited items and Services – Naijads.ng</title>
        <meta
          name="description"
          content="Check what items and services are not allowed to be posted on Naijads.ng. Stay safe, stay compliant, and keep things legit!"
        />
        <link rel="canonical" href="https://naijads.ng/advertisers" />
        <meta property="og:title" content="Prohibited Items – Naijads.ng" />
        <meta
          property="og:description"
          content="Avoid trouble — learn which items or services you must NOT post on Naijads.ng. Stay Naija law-compliant!"
        />
        <meta property="og:url" content="https://naijads.ng/advertisers" />
        <meta property="og:type" content="article" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'PolicyPage',
            name: 'Prohibited Items and Services – Naijads.ng',
            url: 'https://naijads.ng/advertisers',
            description:
              'Find out what types of items and services are prohibited on Naijads.ng in line with Nigerian laws and platform guidelines.',
            about: {
              '@type': 'Organization',
              name: 'Naijads.ng',
              url: 'https://naijads.ng',
              logo: {
                '@type': 'ImageObject',
                url: 'https://naijads.ng/assets/Tayo.svg',
              },
            },
          })}
        </script>
      </Helmet>

      <div className="info-page">
        <div className="info-block-main">
          <h1>Prohibited items and Services</h1>
          <p>
            For your safety and the protection of our online community, certain items and services are strictly <strong>not allowed</strong> on <strong>Naijads.ng</strong>.
            These are based on Nigerian laws and community ethics.
          </p>
        </div>

        <div className="info-block">
          <h3>Illegal or Dangerous items</h3>
          <ul>
            <li>Hard drugs, narcotics, and controlled substances</li>
            <li>Firearms, ammunition, and explosive materials</li>
            <li>Fake or forged documents (e.g., ID cards, driver's licenses)</li>
            <li>Unregistered or stolen vehicles and items</li>
            <li>Items related to human trafficking or child endangerment</li>
          </ul>
        </div>

        <div className="info-block">
          <h3>Health & safety Risks</h3>
          <ul>
            <li>Toxic chemicals, expired medicines, or unverified supplements</li>
            <li>Medical equipment without regulatory approval (e.g., NAFDAC)</li>
            <li>Items that pose harm to consumers or violate public health</li>
          </ul>
        </div>

        <div className="info-block">
          <h3>Restricted consumer Products</h3>
          <ul>
            <li>Alcohol, tobacco, and vaping products</li>
            <li>Pornography or sexually explicit content</li>
            <li>Infant formula and baby medicine not approved by Nigerian authorities</li>
            <li>Cryptocurrencies, foreign exchange speculation, or get-rich-quick offers</li>
            <li>Wild animals, endangered species, or bushmeat sales</li>
          </ul>
        </div>

        <div className="info-block">
          <h3>Services not allowed</h3>
          <ul>
            <li>Escort services or sexual solicitations</li>
            <li>Occultism, charms, and spiritual manipulation offers</li>
            <li>Illegal recruitment or visa/job scams</li>
            <li>Unlicensed financial lending or betting services</li>
            <li>Multi-level marketing and pyramid schemes</li>
          </ul>
        </div>

        <div className="info-block-main">
          <p>
            Any item or service that goes against <strong>Nigerian law, public safety, or platform integrity</strong> is prohibited on Naijads. We dey value honesty, community
            trust, and secure buying/selling for all Nigerians.
          </p>
          <p>
            If you're unsure about your listing, kindly reach out to our support team before posting. Na better safe than sorry!
          </p>
        </div>
      </div>
    </>
  );
};

export default Advertisers;
